module.exports = __webpack_public_path__ + "img/index-reason.0cb348c9.jpg";